<template>
  <div class="report-global-option">
    <ul>
      <li
        v-for="report in reportList"
        :class={active:isCurrentPage(report.key)}
        :key="report.link"
      >
        <div v-if="isCurrentPage(report.key)">{{ $t(report.name) }}</div>
        <div @click="changeReport(report.link)" v-if="!isCurrentPage(report.key)">{{ $t(report.name) }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UIGlobalOption',
  props: {
    reportList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      getQuery: 'report/getQuery'
    })
  },
  methods: {
    isCurrentPage (link) {
      return this.$route.name === link
    },
    changeReport (link) {
      this.$router.push({ path: link })
      this.$emit('changeOptionAction')
    }
  }
}
</script>

<style lang="scss" scoped>
  .report-global-option {
    ul {
      font-size: 15px;
      line-height: 20px;
      li {
        display: inline-block;
        margin-right: 12px;
        margin-bottom: 15px;
        background-color: #FFFFFF;
        border-radius: 4px;
        cursor: pointer;

        div {
          padding: 10px 15px;
          color: #3E5B7E;
          text-decoration: none;
        }

        &.active {
          background-color: #3E5B7E;

          div {
            color: #FFFFFF;
          }
        }
      }
    }
  }
</style>
